var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandBlueskyStyleWhite = function SvgBrandBlueskyStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.837 11.714c-.91-1.77-3.387-5.067-5.69-6.693-2.208-1.558-3.05-1.288-3.601-1.039-.64.29-.755 1.27-.755 1.847s.316 4.73.522 5.424c.682 2.29 3.109 3.065 5.344 2.816q.171-.025.347-.047a7 7 0 0 1-.347.047c-3.275.485-6.184 1.679-2.37 5.926 4.198 4.345 5.752-.931 6.55-3.607.798 2.675 1.717 7.762 6.474 3.607 3.573-3.607.982-5.44-2.294-5.926a7 7 0 0 1-.347-.047q.176.022.347.047c2.235.249 4.662-.525 5.344-2.816.206-.694.523-4.847.523-5.424s-.117-1.558-.755-1.846c-.552-.25-1.394-.52-3.6 1.038-2.304 1.627-4.782 4.924-5.692 6.693"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandBlueskyStyleWhite);
export { ForwardRef as ReactComponent };